import { OpenAPI } from '@/client';

export type AdminRegion = 'singapore' | 'us-east';

const STORAGE_KEY = 'admin_api_region';
const LOCAL_ADMIN_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]']);
const US_EAST_PRIMARY_ADMIN_HOSTS = new Set(['manage-test.gemtoonou.com']);

function isLocalAdminHost(): boolean {
  if (typeof window === 'undefined') return false;
  return LOCAL_ADMIN_HOSTS.has(window.location.hostname.toLowerCase());
}

export function getPrimaryAdminRegion(): AdminRegion {
  if (typeof window === 'undefined') return 'singapore';
  return US_EAST_PRIMARY_ADMIN_HOSTS.has(window.location.hostname.toLowerCase())
    ? 'us-east'
    : 'singapore';
}

function regionalAdminBaseUrl(region: AdminRegion): string {
  if (isLocalAdminHost()) return '/admin';
  return region === 'us-east' ? '/admin-us' : '/admin-ap';
}

export function getAdminRegion(): AdminRegion {
  if (typeof window === 'undefined') return getPrimaryAdminRegion();
  const storedRegion = localStorage.getItem(STORAGE_KEY);
  if (storedRegion === 'us-east' || storedRegion === 'singapore') {
    return storedRegion;
  }
  return getPrimaryAdminRegion();
}

export function adminBaseUrl(region = getAdminRegion()): string {
  return regionalAdminBaseUrl(region);
}

export function initializeAdminRegion(): void {
  OpenAPI.BASE = adminBaseUrl();
}

export function setAdminRegion(region: AdminRegion): void {
  if (typeof window !== 'undefined') localStorage.setItem(STORAGE_KEY, region);
  OpenAPI.BASE = adminBaseUrl(region);
}

export function isAdminRegionConfigured(region: AdminRegion): boolean {
  return region === 'singapore' || !isLocalAdminHost();
}
